import './comp_marksheet_one.css'

const Comp_Marksheet_One=(props)=>{
    return(
        <div class="report-container-tabble-1">
        <div class="logo">
            <img src="logo.png" alt=""/>
            <h4>Pre-Sea Training Institute</h4>
            <h4>DNS Cadets Mid Term Review Report</h4>
        </div>
        <table>
            <tr>
                <th>GUNI-SSTP </th>
                <th>Rev no. : 01</th>
                <th>Date : 01-01-15</th>
                <th>Page 1/1</th>
            </tr>
        </table>


        <table class="second-table">
           <tr>
            <td>Name of Cadet</td>
            <th></th>
           </tr>
           <tr>
            <td>Date of Assessment</td>
            <th></th>
           </tr>
           <tr>
            <td>Time From / To</td>
            <th></th>
           </tr>
           <tr>
            <td>CRB Book No</td>
            <th></th>
           </tr>
           <tr>
            <td>INDOS No</td>
            <th></th>
           </tr>
           <tr>
            <td>Sea Service at the time of Assessment</td>
            <th></th>
           </tr>
           <tr>
            <td>Type of Ships served on</td>
            <th></th>
           </tr>
        </table>

        <table class="third-table">
            <thead>
                <tr >
                    <td colspan="4"><b>CRS Tasks Status (New Book)</b></td>
                </tr>
            </thead>
            <tr>
                <th>Subject</th>
                <th>Semester 3</th>
                <th>Semester 4</th>
                <th>Semester 5</th>
            </tr>
            <tr>
                <td>Navigation</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Cargo</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Security</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>

        <table class="fourth-table">
            <thead>
                <tr >
                    <td colspan="2"><b>Activity Book Status :</b></td>
                </tr>
            </thead>
            <tr>
                <td>Phase 1/2/3 : Approx __________________% done</td>
                <td> Signed by STO</td>
            </tr>
        </table>

        <table class="fifth-table">
            <tr>
                <th colspan="4">Progress Done Onboard</th>
            </tr>
            <tr>
                <td>Navigation : ____ /7</td>
                <td>Controlling Operation of Ship and Care for Persons on Board</td>
            </tr>
            <tr>
                <td>_____ / 14</td>
                <td></td>
            </tr>
            <tr>
                <td>Ship Specific: Type:________________</td>
                <td>Ship Specific: Type:________________</td>
            </tr>
        </table>

        <table class="sixth-table">
            <tr >
                <td></td>
                <th>BRIDGE WATCHES</th>
                <th colspan="3">Total No. of Watches / Hours (Ship1/2/3)</th>
            </tr>
            <tr>
                <td>Total No. of Video/CBTs Seen:</td>
                <td>At Sea</td>
                <td class="centerr">/</td>
                <td class="centerr">/</td>
                <td class="centerr">/</td>
            </tr>
            <tr>
                <td></td>
                <td>At Anchor</td>
                <td class="centerr">/</td>
                <td class="centerr">/</td>
                <td class="centerr">/</td>
            </tr>
            <tr>
                <td>Port Watches:number___hours___</td>
                <td>During Arr&Dep</td>
                <td class="centerr">/</td>
                <td class="centerr">/</td>
                <td class="centerr">/</td>
            </tr>
            <tr>
                <td>E.Rm Watches:number__hours___</td>
                <td>Steering Cert: Yes /No </td>
                <td colspan="2">Hours (day/Night) <br/> D_____ / N_____</td>
                <td>Hours (sight/Arr-Dep) <br/> S_____ / AD_____</td>
            </tr>
        </table>
    </div>
    )
}
export default Comp_Marksheet_One